export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_STATUS = 'SET_STATUS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_INTEGRATION = 'SET_INTEGRATION'
export const SET_INTEGRATIONS = 'SET_INTEGRATIONS'



// WEBPACK FOOTER //
// ./src/store/modules/integrations/types.js